import { Inject, Injectable } from '@angular/core';

import { IToastConfig } from '../interfaces';

@Injectable()
export class ToastService {
    constructor(@Inject('toast') private readonly toast) {}

    public open(config: IToastConfig) {
        if (config.isFull) {
            (config as any).type += ' is-full';
        }

        this.toast({ duration: 5000, ...config, closeOnClick: !config.dismissible });
    }
}
